import { Subject } from 'rxjs';

export class UserAuthManager {
  public static userSessionLogout = new Subject();
}
